<template>
	<div class="detail-page">
		<div class="detail-page__header">
			<h2 class="detail-page__header-title">
				{{ parkServiceDetail.title }}
			</h2>
			<p class="detail-page__header-time">
				发布时间：{{ parkServiceDetail.create_time | formatDate }}
			</p>
		</div>
		<div
			class="detail-page__content"
			v-html="parkServiceDetail.content"
		></div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	name: 'HatchingServiceDetail',
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState('FHFW', ['parkServiceDetail']),
		// 翻页
		turnPageUrl() {
			const orgPath = this.$route.fullPath
			const len = orgPath.lastIndexOf('/') + 1
			return orgPath.substr(0, len)
		},
	},
	mounted() {
		const pathMatch = this.$route.params.pathMatch || ''
		const mapSource = ['parkService']
		const params = {
			id: this.$route.params.id,
			parkType: mapSource.indexOf(pathMatch) + 1,
		}
		this.fetchParkServiceDetail(params)
	},
	watch: {},
	methods: {
		...mapActions('FHFW', ['fetchParkServiceDetail']),
	},
	components: {},
}
</script>

<style lang="scss"></style>
